// extracted by css-extract-rspack-plugin
module.exports =  {"taskCompletion":"Milestones__taskCompletion___MGGok","taskTitle":"Milestones__taskTitle___IauhE"};